<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<idt-common-styles-render
  *ngIf="piece"
  [styles]="settings?.styles">
  <div *ngIf="hasToShowTitle || hasToShowSubtitle">
    <render-wysiwyg
      *ngIf="hasToShowTitle"
      [ngStyle]="titlePadding"
      [html]="titleContent"
      [country]="country"
      [lang]="lang"
      [piece]="piece">
    </render-wysiwyg>
    <render-wysiwyg
      *ngIf="hasToShowSubtitle"
      [html]="subtitleContent"
      [ngStyle]="subtitlePadding"
      [country]="country"
      [lang]="lang"
      [piece]="piece">
    </render-wysiwyg>
  </div>
  <form
    *ngIf="hasToShowForm"
    [formGroup]="form"
    (ngSubmit)="onSubmit()">

    <ng-container *ngIf="showUnsuscribeForm; then unsuscribeForm; else suscribeForm"></ng-container>

    <ng-template #unsuscribeForm>
      <ng-container *ngIf="!showUnsuscribeMessage; else unsuscribeMessage">
        <ng-template *ngTemplateOutlet="inputContainer">
        </ng-template>

        <button
          type="submit"
          class="block">
          <render-wysiwyg
            [html]="settings?.general?.links?.unsubscribe?.text"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </button>
      </ng-container>
    </ng-template>

    <ng-template #suscribeForm>
      <ng-template *ngTemplateOutlet="inputContainer">
      </ng-template>
      <div
        *ngIf="linkedCategories.length > 0"
        class="categories">
        <div
          *ngIf="settings?.general?.categories?.displayCategoriesTitleToggle"
          [ngStyle]="getPaddingStyles('titleText', true, settings?.general?.categories)"
          class="wysiwyg">
          <render-wysiwyg
            [html]="getTextByDevice(settings?.general?.categories, 'titleText')"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </div>
        <div class="linked-categories">
          <div *ngFor="let linkedCategory of linkedCategories; let i = index; trackBy: trackByIndex">
            <label
              class="checkbox-container"
              [htmlFor]="'category_' + i"
              >
              <input
                *ngIf="form.controls.linkedCategories.at(i) as checkbox"
                type="checkbox"
                [ngStyle]="commonBackgroundColor"
                [name]="'category_' + i"
                [formControl]="checkbox">
              <render-wysiwyg
                [html]="linkedCategory.title"
                [country]="country"
                [lang]="lang"
                [piece]="piece">
              </render-wysiwyg>
            </label>
          </div>
        </div>
        <div
          *ngIf="isFormSubmitted && isRequiredCategories"
          class="error-message">
          {{ requiredCategoriesMessage }}
        </div>
      </div>
      <div
        class="agree-text"
        [ngStyle]="getPaddingStyles('text')">
        <input
          required
          name="agree"
          type="checkbox"
          [ngStyle]="commonBackgroundColor"
          formControlName="agree">
        <div
          *ngIf="settings?.general?.text"
          class="wysiwyg">
          <render-wysiwyg
            [html]="settings?.general?.text"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </div>
      </div>
      <div
        *ngIf="legalConditionsInvalid"
        class="legal-conditions-error"
      >
        <span class="error-message">{{settings?.general?.legalErrorMessage}}</span>
      </div>
      <div
        *ngIf="fieldsBirthdate && fieldsBirthdate?.formatBirthdate"
        class="birthdate-text">
        <div
          *ngIf="settings?.general?.birthdate?.titleText"
          [ngStyle]="getPaddingStyles('titleText', true, settings?.general?.birthdate)"
          class="wysiwyg">
          <render-wysiwyg
            [html]="getTextByDevice(settings?.general?.birthdate, 'titleText')"
            [country]="country"
            [lang]="lang"
            [piece]="piece">
          </render-wysiwyg>
        </div>
      </div>
      <div
        *ngIf="fieldsBirthdate && fieldsBirthdate?.formatBirthdate"
        class="birthdate-container"
        formGroupName="birthdate">
        <div
          class="birthdate-status">
          <div
            class="birthdate-wrapper"
            [ngStyle]="commonBackgroundColor"
            >
            <input
              name="day"
              type="number"
              maxLength="2"
              min="0"
              max="31"
              formControlName="day"
              [ngStyle]="inputStyle"
              class="input-custom-style"
              [placeholder]="fieldsBirthdate.dayPlaceholder ?? ''">
          </div>
          <span
            *ngIf="isFormSubmitted && form.controls.birthdate!.controls.day?.invalid"
            class="error-message">
            {{ messageMandatoryBirthdate }}
          </span>
        </div>
        <div class="birthdate-status">
          <div
            class="birthdate-wrapper"
            [ngStyle]="commonBackgroundColor">
            <input
              name="month"
              type="number"
              maxLength="2"
              min="0"
              max="12"
              formControlName="month"
              [ngStyle]="inputStyle"
              class="input-custom-style"
              [placeholder]="fieldsBirthdate.monthPlaceholder ?? ''">
          </div>
          <span
            *ngIf="isFormSubmitted && form.controls.birthdate!.controls.month?.invalid"
            class="error-message">
            {{ messageMandatoryBirthdate }}
          </span>
        </div>
        <div
          *ngIf="fieldsBirthdate.formatBirthdate === 'dayMonthYear'"
          class="birthdate-status">
          <div
            class="birthdate-wrapper"
            [ngStyle]="commonBackgroundColor">
            <input
              name="year"
              type="number"
              maxLength="4"
              min="0"
              max="9999"
              formControlName="year"
              [ngStyle]="inputStyle"
              class="input-custom-style"
              [placeholder]="fieldsBirthdate.yearPlaceholder ?? ''">
          </div>
          <span
            *ngIf="isFormSubmitted && form.controls.birthdate!.controls.year?.invalid"
            class="error-message">
            {{ messageMandatoryBirthdate }}
          </span>
        </div>
      </div>
      <ng-container
        *ngIf="isBlockButton; then submitButton;">
      </ng-container>
      <div
        *ngIf="hasLinks"
        class="links">
        <a
          *ngIf="settings.general.links?.unsubscribeToggle"
          (click)="showUnsuscribeForm = true">
          {{ settings.general.links?.unsubscribe?.text ?? '' }}
        </a>
        <a
          *ngIf="settings.general.links?.legalConditionsToggle"
          target="_blank"
          rel="noopener"
          [href]="settings.general.links?.legalConditions?.url ?? ''">
          {{ settings.general.links?.legalConditions?.text ?? '' }}
        </a>
      </div>
    </ng-template>

    <ng-template #inputContainer>
      <div
        class="input-container"
        [ngStyle]="containerStyle">
        <div
        class="email-wrapper">
          <input
            name="email"
            type="email"
            formControlName="email"
            [ngStyle]="inputStyle"
            class="input-custom-style"
            [placeholder]="settings?.general?.placeholder ?? ''"
            (input)="resetFormSubmitted()">
          <div
            [ngSwitch]="status"
            class="email-status">
            <ng-container *ngSwitchCase="'loading'">
              <img
                *ngIf="settings?.general?.customIconLoading?.image; else loadingIcon"
                alt="loading"
                [src]="getCustomIcon(settings!.general.customIconLoading!.image!)">
              <ng-template #loadingIcon>
                <svg
                  x="0px"
                  y="0px"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="25 25 50 50">
                    <path
                      fill="#000"
                      d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                      <!-- htmllint tag-name-lowercase="false" -->
                      <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="rotate"
                        dur="1s"
                        from="0 50 50"
                        to="360 50 50"
                        repeatCount="indefinite">
                      </animateTransform>
                    </path>
                </svg>
              </ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'failure'">
              <img
                *ngIf="settings?.general?.customIconFailure?.image; else failureIcon"
                alt="failure"
                [src]="getCustomIcon(settings!.general.customIconFailure!.image!)">
              <ng-template #failureIcon>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM6.96198 15.9769L8.02263 17.0376L12 13.0602L15.9774 17.0376L17.0381 15.977L13.0607 11.9996L17.0381 8.02217L15.9774 6.96152L12 10.9389L8.02262 6.96154L6.96198 8.02219L10.9394 11.9996L6.96198 15.9769Z"
                    fill="#FF6767" />
                </svg>
              </ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'success'">
              <img
                *ngIf="settings?.general?.customIconSuccess?.image; else successIcon"
                alt="success"
                [src]="getCustomIcon(settings!.general.customIconSuccess!.image!)">
              <ng-template #successIcon>
                <svg
                  viewBox="0 0 24 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22.7486 0.687439L8.62612 14.8098L1.2514 7.4352L0 8.6866L8.62612 17.3126L24 1.93884L22.7486 0.687439Z"
                    fill="#39AC99"/>
                </svg>
              </ng-template>
            </ng-container>
          </div>
        </div>
        <ng-container
        *ngIf="!isBlockButton && !showUnsuscribeForm; then submitButton;">
      </ng-container>
    </div>
    <div
      *ngIf="settings.general.showCustomEmailErrorToggle && emailInvalid"
      class="error-message email-error"
      >
      {{settings.general.customEmailError}}
    </div>
    </ng-template>

    <ng-template #submitButton>
      <button
        type="submit"
        [class.block]="isBlockButton"
        [disabled]="type === 'render' && !isFormReady"
        >
        <ng-container *ngIf="buttonType === 'icon'; then iconButton; else textButton">
        </ng-container>
      </button>
    </ng-template>

    <ng-template #iconButton>
      <img
        *ngIf="hasCustomIconButton; else defaultIconButton"
        class="custom-icon"
        alt="Enviar"
        [src]="getCustomIcon(settings!.general.customIconButton!.image!)"/>
    </ng-template>

    <ng-template #defaultIconButton>
      <svg
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.072 8.024L5.715 3.667l.618-.62L11 7.716v.618L6.333 13l-.618-.619 4.357-4.357z"/>
      </svg>
    </ng-template>

    <ng-template #textButton>
      <render-wysiwyg
        [html]="getTextByDevice(settings?.general?.buttonSubmitStyles, 'text')"
        [country]="country"
        [lang]="lang"
        [piece]="piece">
      </render-wysiwyg>
    </ng-template>

    <ng-template #unsuscribeMessage>
      <render-wysiwyg
        [ngStyle]="getPaddingStyles('padding', false, settings.general.links?.unsubscribe)"
        [html]="settings?.general?.links?.unsubscribe?.successText"
        [country]="country"
        [lang]="lang"
        [piece]="piece">
      </render-wysiwyg>
    </ng-template>

  </form>
</idt-common-styles-render>
